

export const soraFeatures = {
    title: 'Why Choose Our Sora 2 AI Video Generator',
    sub: "OpenAI's Sora 2 represents a breakthrough in AI video generation.",
    items: [
      { num: '01', title: 'Advanced Physics Simulation & Realistic Motion', text: 'Unprecedented physical accuracy and motion realism; objects maintain coherence across complex sequences.' },
      { num: '02', title: 'Dual-Mode Generation – Text to Video & Image to Video', text: 'Create from text prompts or transform static images into dynamic sequences while maintaining coherence.' },
      { num: '03', title: 'Flexible Output & Aspect Ratios for Any Platform', text: 'Up to 15 seconds in portrait or landscape formats with HD rendering, optimized for platforms.' },
      { num: '04', title: 'Precise Creative Control & Style Versatility', text: 'Fine-grained control over scenes, actions, and styles—photorealistic, cinematic, or stylized.' }
    ]
  };
